// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1MBbl","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__CKABh"};